import React from 'react';
import { Tag } from 'antd';

import { RightSidebar } from "src/pages/_partials/Layout";
import { UserInterface } from "src/store/callrecorder/usersSlice";
import { selectBundleById } from "src/store/callrecorder/bundlesSlice";
import { selectProviderById } from "src/store/callrecorder/providersSlice";
import { selectUserNumberById } from "src/store/callrecorder/userNumbersSlice";
import { useAppSelector, useAppDispatch } from "src/store/hooks";
import { fetchProviders } from "src/actions/callrecorder/providersActions";
import RowInfo from "src/componets/RowInfo";
import OptionalLink from "src/componets/OptionalLink";
import { formattedDate } from "src/helpers/DateHelpers";

const boolTag = (val: boolean) =>
  val ? <Tag color="success">yes</Tag> : <Tag color="default">no</Tag>;

const _SidebarShow = ({ record }: { record: UserInterface | undefined }) => {
  const dispatch = useAppDispatch();
  const bundle = useAppSelector(state => record ? selectBundleById(state, record.bundle) : undefined);
  const provider = useAppSelector(state => record?.provider_id ? selectProviderById(state, record.provider_id) : undefined);
  const userNumber = useAppSelector(state => record?.user_number ? selectUserNumberById(state, record.user_number) : undefined);
  const providersStatus = useAppSelector(state => state.callrecorder.providers.status);

  React.useEffect(() => {
    if (record?.provider_id && !provider && providersStatus === 'idle') {
      dispatch(fetchProviders({}));
    }
  }, [record?.provider_id, provider, providersStatus, dispatch]);

  const renderDetails = () => {
    if (!record) {
      return null;
    }

    return (
      <>
        <div className='v-mb-20'>
          <h6 className='v-content-label o-sm'>Identity</h6>

          <RowInfo left='#ID' right={record.id} />
          <RowInfo left='DST' right={record.cnumber} />
          <RowInfo left='Reg SRC' right={record.reg_cid || '—'} />
        </div>

        <div className='v-mb-20'>
          <h6 className='v-content-label o-sm'>Account</h6>

          <RowInfo left='Balance' right={record.balance} />
          <RowInfo left='Verified' right={boolTag(record.verified)} />
          <RowInfo left='Suspicious' right={record.suspicious ? <Tag color="error">yes</Tag> : <Tag color="default">no</Tag>} />
          <RowInfo left='Ads' right={boolTag(record.ads)} />
          <RowInfo left='Recording' right={boolTag(record.rec)} />
        </div>

        <div className='v-mb-20'>
          <h6 className='v-content-label o-sm'>Settings</h6>

          <RowInfo left='Voice Changer' right={record.voice_changer} />
          <RowInfo left='Bundle' right={
            bundle ? <OptionalLink link={bundle.url}>{bundle.name}</OptionalLink> : `#${record.bundle_id}`
          } />
          <RowInfo left='Provider' right={
            record.provider_id
              ? (provider ? <OptionalLink link={provider.url}>{provider.name}</OptionalLink> : `#${record.provider_id}`)
              : '—'
          } />
          <RowInfo left='BG Noise' right={record.bg_noise_id ? `#${record.bg_noise_id}` : '—'} />
        </div>

        <div className='v-mb-20'>
          <h6 className='v-content-label o-sm'>System</h6>

          <RowInfo left='Server IP' right={record.serverip || '—'} />
          <RowInfo left='Pushkit Token' right={record.pushkit_token ? <small>{record.pushkit_token}</small> : '—'} />
          <RowInfo left='FCM Token' right={record.fcm_token ? <small>{record.fcm_token}</small> : '—'} />
          <RowInfo left='DNO ID' right={record.dno_id || '—'} />
          <RowInfo left='User Number' right={
            userNumber
              ? `${userNumber.number} (${userNumber.number_type})`
              : '—'
          } />
        </div>
      </>
    )
  }

  return (
    <RightSidebar collapsible>
      <h6 className='v-content-label'>USER DETAILS</h6>
      <hr className="v-divider" />

      {renderDetails()}
    </RightSidebar>
  )
}

export default _SidebarShow;
